import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Authenticated fetch wrapper.
 * Sends credentials (httpOnly cookie) with every request.
 */
export async function authFetch(url, options = {}) {
  const res = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      ...options.headers,
    },
  });
  if (res.status === 401) {
    localStorage.removeItem('cefat_user');
    if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin') {
      window.location.href = '/admin';
    }
  }
  return res;
}

/**
 * Get current user info from localStorage (non-sensitive display data only).
 */
export function getCurrentUser() {
  try {
    return JSON.parse(localStorage.getItem('cefat_user') || '{}');
  } catch {
    return {};
  }
}

/**
 * Login: store user display info, cookie is set automatically by the server.
 */
export async function login(email, password) {
  const res = await fetch(`${API_URL}/api/auth/login`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email.toLowerCase().trim(), password }),
  });
  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.detail || 'Erreur de connexion');
  }
  const data = await res.json();
  localStorage.setItem('cefat_user', JSON.stringify(data.user));
  return data;
}

/**
 * Logout: clear cookie + localStorage.
 */
export async function logout() {
  try {
    await fetch(`${API_URL}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch { /* ignore */ }
  localStorage.removeItem('cefat_user');
}
